import { api } from "../network/api";
import { ENDPOINTS } from "@/constants/endpoints";

export interface MaintenanceStatus {
  isEnabled: boolean;
  message: string | null;
}

const MaintenanceService = {
  getStatus: async (): Promise<MaintenanceStatus> => {
    const response = await api.get(ENDPOINTS.MAINTENANCE.STATUS);
    return response.data;
  },
};

export default MaintenanceService;
